import React from 'react'
import { Box, Typography } from '@mui/material'
import { TESTIDS } from '../../../../config/testids'
import { sprintCallPageSx, sprintCallStageSx, sprintCallTitleSx } from './sprintCallPageStyles'

interface SprintCallPageLayoutProps {
  title: string
  children: React.ReactNode
}

/** The page of a call the whole sprint holds: its name at the top left, then the call as large as the screen allows. */
export const SprintCallPageLayout: React.FC<SprintCallPageLayoutProps> = ({ title, children }) => (
  <Box sx={sprintCallPageSx} data-testid={TESTIDS.SPRINT_CALL_PAGE}>
    <Typography component="h1" sx={sprintCallTitleSx}>
      {title}
    </Typography>

    <Box sx={sprintCallStageSx}>{children}</Box>
  </Box>
)
